import { Link } from '@tanstack/react-router';
import { EyeOff } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/components/ui/empty-state';
import { useAuth } from '@/lib/auth';
import { FEATURES, useFeatures, type Feature } from '@/lib/features';

/**
 * מסך של מודול שכבוי לעסק (קישור ישן, סימנייה) — הסבר ודרך להפעיל,
 * לא מסך ריק. זו חוויה, לא הרשאה.
 */
export function RequireFeature({ feature, children }: { feature: Feature; children: ReactNode }) {
  const { t } = useTranslation();
  const { has } = useFeatures();
  const { can } = useAuth();
  if (has(feature)) return <>{children}</>;
  return (
    <EmptyState
      icon={EyeOff}
      title={t('featureOff.title', { feature: FEATURES[feature].label })}
      description={t('featureOff.description', { hint: FEATURES[feature].hint })}
      action={
        can('OWNER') ? (
          <Link to="/settings/$tab" params={{ tab: 'features' }} className="text-sm font-medium text-accent hover:underline">
            {t('featureOff.enable')}
          </Link>
        ) : undefined
      }
    />
  );
}
